import React from 'react';
import styled from '@emotion/styled';
import ReactMarkdown from 'react-markdown';

const Container = styled.div`
  min-height: 100vh;
  background-color: #f5f5f7;
  padding: 2rem;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background: white;
  padding: 2rem;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  flex: 1;
`;

const Title = styled.h1`
  color: #1d1d1f;
  margin-bottom: 2rem;
  font-size: 2rem;
  text-align: center;
`;

const MarkdownContainer = styled.section`
  margin-bottom: 2rem;
  h1 {
    color: #1d1d1f;
    margin-bottom:0.5rem;
    font-size: 1.5rem;
  }
  h2 {
    color: #1d1d1f;
    margin-bottom: 0.5rem;
    font-size: 1.0rem;
  }

  p {
    color: #6e6e73;
    line-height: 1.6;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
  }
`;

const Footer = styled.footer`
  text-align: center;
  padding: 1rem 0;
  color: #86868b;
  font-size: 0.9rem;
`;

function CleanTextAiPrivacyPolicyKo() {
  const currentYear = new Date().getFullYear();
  const markdownContent = `
 # 개인정보 처리방침

"학습 AI"(이하 "본 앱")은 사용자의 프라이버시를 존중하며 개인정보 보호에 최선을 다하고 있습니다. 본 앱은 사용자의 개인정보를 수집하지 않으며, 사용자의 데이터를 보호하기 위한 조치를 취하고 있습니다. 본 개인정보 처리방침(이하 "본 방침")은 본 앱에서의 정보 처리에 대해 규정합니다.

## 제1조(개인정보의 수집 및 관리 방침)

본 앱은 사용자의 어떠한 개인정보(이름, 주소, 전화번호, 이메일 주소 등)도 수집하지 않습니다. 앱 내의 모든 기능은 개인정보를 수집하지 않는 것을 전제로 설계되어 있습니다. 또한, 사용자의 프라이버시 보호를 위해 개인정보 보호법에 따라 개인을 식별할 수 있는 정보의 수집이나 저장을 일절 하지 않습니다.

## 제2조(숙제・시험 문제의 이미지 및 데이터 저장)

본 앱에서는 사용자가 촬영한 숙제와 시험 문제 이미지, 스캔한 문서, 손글씨 제거 처리 후의 데이터는 모두 사용자의 기기 내에만 저장되며, 앱 외부의 서버 등에 저장되지 않습니다. 따라서 사용자가 촬영하고 저장한 이미지와 데이터에 대해 본 앱 및 개발사는 일절 접근하지 않습니다. 또한, 이러한 이미지 데이터는 제3자에게 제공되지 않으며, 사용자의 기기 내에서 안전하게 보관됨을 보증합니다.

## 제3조(AI 문제 해답 기능에 대해)

본 앱에서는 사용자가 촬영한 문제 이미지를 AI에 전송하여 해답을 얻는 기능을 제공하고 있습니다. 이 기능을 이용할 때, 문제 이미지는 일시적으로 외부 AI 서비스에 전송되지만, 개인을 특정할 수 있는 정보는 포함되지 않습니다. 전송된 이미지는 해답 처리 후 삭제되며, 장기 보존되지 않습니다. 또한, AI 서비스 제공업체는 해당 이미지를 다른 목적으로 사용하지 않습니다. 이 기능의 이용은 임의이며, 사용자는 언제든지 이용을 중단할 수 있습니다.

## 제4조(카메라 및 사진 라이브러리 접근)

본 앱에서는 숙제와 시험 문제의 촬영 및 스캔 기능을 제공하기 위해 사용자 기기의 카메라 및 사진 라이브러리에 대한 접근 권한을 요청할 수 있습니다. 이러한 권한은 앱의 기본 기능을 실행하기 위해서만 사용되며, 허가 없이 사용자의 사진이나 카메라 기능에 접근하지 않습니다. 또한, 접근 권한은 사용자가 언제든지 기기 설정에서 변경하거나 취소할 수 있습니다.

## 제5조(데이터 암호화와 보안)

본 앱에서는 사용자 데이터 보호를 위해 기기 내에 저장되는 모든 데이터에 대해 적절한 암호화 기술을 사용하고 있습니다. 또한, 앱 이용 중에 발생할 수 있는 보안 위험을 최소화하기 위해 정기적인 보안 업데이트를 실시하고 있습니다. 다만, 사용자 기기 자체의 보안에 대해서는 사용자 스스로 적절한 관리를 부탁드립니다.

## 제6조(앱 이용 상황 분석)

본 앱에서는 서비스 향상을 위해 개인을 특정할 수 없는 범위에서 앱의 이용 상황(기능 사용 빈도, 오류 발생 상황 등)을 분석할 수 있습니다. 이러한 분석 데이터에는 개인정보가 포함되지 않으며, 통계적인 정보만을 수집하여 앱 개선 및 새로운 기능 개발에만 사용됩니다.

## 제7조(제3자 서비스와의 연계)

본 앱에서는 AI 문제 해답 기능에서 제3자의 AI 서비스를 이용하고 있습니다. 이러한 서비스 제공업체는 각각 독자적인 개인정보 처리방침을 가지고 있으며, 사용자 데이터의 취급에 대해서는 각 서비스 제공업체의 방침에 따릅니다. 본 앱에서는 이러한 제3자 서비스에 전송하는 데이터를 최소한으로 억제하고, 개인정보가 포함되지 않도록 배려하고 있습니다.

## 제8조(사용자 권리와 데이터 관리)

본 앱은 사용자가 자신의 데이터를 완전히 관리할 수 있도록 배려하고 있습니다. 사용자는 언제든지 앱 내의 데이터를 삭제할 수 있으며, 본 앱은 사용자의 조작이 없는 한 데이터를 외부로 전송하지 않습니다(AI 문제 해답 기능 제외). 또한, 이용약관에 따라 본 앱의 이용에 있어 개인정보를 이용하지 않으므로, 정보의 공개, 정정, 삭제, 이용 정지에 관한 요청은 해당되지 않습니다.

## 제9조(법적 요청에 대한 대응)

본 앱에서는 개인정보를 수집하지 않으므로, 통상의 경우 법 집행 기관 등으로부터의 정보 공개 요청에 응할 수 없습니다. 다만, 법적으로 유효한 영장이나 법원 명령 등이 있는 경우에는 법령에 따라 적절히 대응하겠습니다.

## 제10조(개인정보 처리방침의 변경)

본 앱은 본 방침의 내용을 수시로 검토하고, 사용자의 프라이버시 보호 향상을 위해 법령의 개정이나 앱 기능의 변경 등에 따라 본 방침을 변경할 수 있습니다. 변경이 있는 경우, 최신의 개인정보 처리방침을 본 앱 내에 게시함으로써 사용자에게 통지하고, 게시와 동시에 효력이 발생하는 것으로 합니다. 사용자는 정기적으로 본 방침을 확인해 주시기 바랍니다.

## 제11조(문의 창구)

본 방침에 관한 문의나 불명확한 점이 있으시면, 아래의 연락처로 연락해 주시기 바랍니다. 프라이버시에 관한 질문이나 우려사항이 있으시면 언제든지 문의해 주시기 바랍니다.

이메일 주소：linappworks@gmail.com

최종 업데이트 날짜：2025년 8월 20일
  `;

  return (
    <Container>
      <Content>
        <Title>개인정보 처리방침</Title>
        <MarkdownContainer>
          <ReactMarkdown>{markdownContent}</ReactMarkdown>
        </MarkdownContainer>
      </Content>
      <Footer>
        <p>© {currentYear} linappworks. All rights reserved.</p>
        <p>Contact us: linappworks@gmail.com</p>
      </Footer>
    </Container>
  );
}

export default CleanTextAiPrivacyPolicyKo; 
